




import Vue from 'vue';
import CustomFields from '@/common/components/support/CustomFields.vue';

export default Vue.extend({
  components: {
    CustomFields,
  },
});
